module.exports = __webpack_public_path__ + "static/media/BulkReturn3.b880ebf3.png";